var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`notice notice-${_vm.type}`},[(_vm.icon)?_c('div',{staticClass:"notice-icon"},[_c('i',{class:_vm.icon})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"notice-content"},[_vm._v("\n\t\t"+_vm._s(_vm.msg)+"\n\t")])])
}
var staticRenderFns = []

export { render, staticRenderFns }